import { CSSProperties, memo, useMemo } from "react";
import { GetLongDate } from "../../utils/GetLongDate";
import { Event } from "@markit/common.types";
import {
  GetTime,
  getTimeZoneAbbreviation,
  getTimezoneTimestamp,
  isMultipleDays,
} from "@markit/common.utils";
import { useTheme } from "../../hooks/useTheme";

type EventDateTimeDisplayProps = {
  event: Event;
  className: string;
  containerStyles?: CSSProperties;
  textStyles?: CSSProperties;
  shortDayName?: boolean;
};

// Utilize wherever we need to display the event date and time in a compact format
const EventDateTimeDisplay = memo(function EventDateTimeDisplayFn(
  props: EventDateTimeDisplayProps
) {
  const { event, className, containerStyles, textStyles, shortDayName } = props;
  const { theme } = useTheme();

  const timezoneStart = useMemo(
    () => getTimezoneTimestamp(event.start, event.timezone),
    [event.start, event.timezone]
  );

  const timezoneEnd = useMemo(
    () => getTimezoneTimestamp(event.end, event.timezone),
    [event.end, event.timezone]
  );

  return (
    <div
      className={className}
      style={{ gap: 4, flexWrap: "wrap", ...containerStyles }}
    >
      <span
        className="bodyMedium"
        style={{ ...theme.PrimaryText, ...textStyles }}
      >
        {GetLongDate(timezoneStart, shortDayName, true, true)}
      </span>
      <span
        className="bodySubtext"
        style={{ ...theme.LabelText, ...textStyles }}
      >
        {GetTime(timezoneStart)} to{" "}
        {isMultipleDays(timezoneStart, timezoneEnd) &&
          GetLongDate(timezoneEnd, shortDayName, true, false)}{" "}
        {GetTime(timezoneEnd)} {getTimeZoneAbbreviation(event.timezone)}
      </span>
    </div>
  );
});

export default EventDateTimeDisplay;
